// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__TLb1X","nav":"styles_nav__UqWho"};